import React from "react";
import Button from "antd/lib/button";
import Icon from "antd/lib/icon";
import locales from "../locales";

interface Props {
  idString: string;
  type: "rental"|"returnal";
  hasTransportLetter?: boolean;
  onClick: () => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}

class IdStringLabel extends React.Component<Props, any> {

  public render() {
    const {idString, type, hasTransportLetter, onClick, onMouseOver, onMouseOut} = this.props;

    const title = type === "rental" ? locales.view_rental : locales.view_returnal;
    const icon = type === "rental" ? "upload" : "download";

    return (
      <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <span>{idString}</span>
        {hasTransportLetter && <Icon type="solution" title={locales.transport_letter} style={{marginLeft: 8}}/>}
        <Button
          icon={icon}
          title={title}
          style={{minWidth: 32, width: 32, marginLeft: 12}}
          onClick={onClick}
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        />
      </div>
    );
  }
}

export default IdStringLabel;



// WEBPACK FOOTER //
// ./src/rental/IdStringLabel.tsx